(function () {
	'use strict';

    angular.module("imApp").factory("selectGlyphiconService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1407,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
